import { action } from 'satcheljs';
import type { BookingPageErrorState } from 'bookwithme-shared';

/**
 * Action to set booking page error state in the store.
 */
export const setBookingPageErrorState = action(
    'setBookingPageErrorState',
    (errorState: BookingPageErrorState) => ({
        errorState,
    })
);
